import { createLabeledMessages } from '../../../messageUtils';
const delegations = {
    enter: 'Vstoupit',
    inDelegations: 'v zástupu',
    orInDelegations: 'nebo v zástupu',
    genericError: ' Došlo k neočekávané chybě.',
    userHasNoPermissions: 'Uživatel nemá právo vstoupit do aplikace.',
    cannotDelegate: 'Do této aplikace nemáte právo zástupu za {{representativeFor}}. Budete přihlášen pod svým jménem.'
};
export default Object.assign({}, delegations, createLabeledMessages(delegations));
